
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import elecEchart from "./components/elec-echart.vue";
import pileEchart from "./components/pile-echart.vue";
import dataModal from "./components/data-modal.vue";
import piSelectOper from "@/components/select-oper/select-oper.vue";
import selectStation from "@/components/select-station/select-station.vue";
import selectCity from "@/components/select-city/select-city.vue";
import selectMch from "@/components/select-mch/select-mch.vue";
import selectPile from "@/components/select-pile/select-pile.vue";
import { echartsJS } from "@/common/add-js";
// import { State } from "vuex-class";
import { getOptData, getOptTodayData } from "@/api/api-operation-service";
import i18n from "@/config/i18n";
@Component({
  components: {
    "pi-elec-echart": elecEchart,
    "pi-pile-echart": pileEchart,
    "pi-data-model": dataModal,
    piSelectOper,
    "pi-select-station": selectStation,
    "pi-select-city": selectCity,
    "pi-select-mch": selectMch,
    "pi-select-pile": selectPile
  }
})
export default class PiOperData extends Vue {
  // @State("sys") sys!: objAny;
  // @Watch("sys.operInfo", { immediate: true, deep: true })
  // "watch.operInfo"(newVal: objAny) {
  //   if (newVal.oprPkId) {
  //     this.formInline.oprPkId = newVal.oprPkId;
  //   }
  // }
  private elecEchart: objAny = {};
  private pileEchart: objAny = {};
  private dataModal: objAny = {};
  private startDate = "";
  private endDate = "";

  private optData: objAny = {};
  private optTodayData: objAny = {};

  private formInline: objAny = {
    regionId: "",
    oprPkId: "",
    staPkId: "",
    merchantPkId: "",
    startDate: "",
    endDate: "",
    pilePkId: ""
  };
  private cityArr: number[] = [];

  public querySearch() {
    if (!this.formInline.staPkId) {
      this.$Message.error(i18n.t("operationData.noStaPkId"));
      return;
    }
    if (this.formInline.startDate == "" || this.formInline.endDate == "") {
      this.$Message.error(i18n.t("formText.selectTimePl"));
    } else if (
      !this["$common"].startEndTime(
        this.formInline.startDate,
        this.formInline.endDate
      )
    ) {
      this.$Message.error(i18n.t("formText.timeMax"));
    } else {
      this.showEchart();
      this.getOptTodayData();
      this.getOptData();

      setTimeout(() => {
        this.elecEchart.init();
        this.pileEchart.init();
      }, 500);
    }
  }
  public startTimeChange(val: string) {
    this.formInline.startDate = val || "";
  }
  public endTimeChange(val: string) {
    this.formInline.endDate = val || "";
  }
  public showModel(item: string, color: string, name: string) {
    if (this.formInline.staPkId == "") {
      this.$Message.error(i18n.t("operationData.noStaPkId"));
    } else {
      this.dataModal.open(item, color, name);
    }
  }
  async getOptData(): Promise<void> {
    const params = {
      endDate: this.formInline.endDate,
      pilePkId: this.formInline.pilePkId,
      staPkId: this.formInline.staPkId,
      startDate: this.formInline.startDate
    };
    // const ret = await getOptData(this["$common"].forNull(this.formInline));
    const ret = await getOptData(params);

    if (ret.status === this.$config.apiStatus) {
      this.optData = ret.data[0] || {};
    }
  }

  async getOptTodayData(): Promise<void> {
    const ret = await getOptTodayData({});
    if (ret.status === this.$config.apiStatus) {
      this.optTodayData = ret.data[0] || {};
    }
  }

  async showEchart() {
    this.$nextTick(async () => {
      await echartsJS();
      this.elecEchart = this.$refs["elecEchart"];
      this.pileEchart = this.$refs["pileEchart"];
      this.dataModal = this.$refs["dataModal"];
      // this.querySearch();
    });
  }
  mounted() {
    this.$nextTick(async () => {
      await echartsJS();
      this.elecEchart = this.$refs["elecEchart"];
      this.pileEchart = this.$refs["pileEchart"];
      this.dataModal = this.$refs["dataModal"];
      // this.querySearch();
    });
  }
  created() {
    const endDate = this.$common.thisTimes("yyyy-MM-dd");
    const startDate = this.$common.thisTimes("yyyy-MM") + "-01";
    this.startDate = startDate + "";
    this.endDate = endDate + "";
    this.formInline.startDate = startDate;
    this.formInline.endDate = endDate;
  }
}
